import { BlockStack, Modal, Text } from "@shopify/polaris"
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import { useNavigate } from "react-router-dom";

export default function CreditsPopup({ open, onClose }) {

  const { navigate } = useNavigate()

  const { user } = usePartnerUp()

  const credits = (user?.credits || 0) + (user?.fixedCredits || 0)

  let content = null;
  if (open === 'welcome') {
    content = (
      <BlockStack gap="200" inlineAlign="center">
        <img width="60%" src="https://assets.codepen.io/6060109/coins-done.png" alt="" />
        <Text tone="subdued">Welcome to PartnerUp!</Text>
        <Text variant="headingLg">You Have 15 Free Credits</Text>
        <Text>Use Search, or Install the Chrome Extension to Start Finding Influencers</Text>
      </BlockStack>
    )
  } else if (open === 'lowCredits') {
    content = (
      <BlockStack gap="200" inlineAlign="center">
        <img width="60%" src="https://assets.codepen.io/6060109/coins-done.png" alt="" />
        <Text tone="subdued">Low Credits</Text>
        <Text variant="headingLg">You Have {credits} Credits Remaining</Text>
        <Text>You can upgrade your plan or buy fixed credits for more</Text>
      </BlockStack>
    )
  } else if (open === 'noCredits') {
    content = (
      <BlockStack gap="200" inlineAlign="center">
        <img width="60%" src="https://assets.codepen.io/6060109/coins-done.png" alt="" />
        <Text tone="subdued">No Credits</Text>
        <Text variant="headingLg">You're Out of Credits</Text>
        <Text>You can upgrade your plan or buy fixed credits for more</Text>
      </BlockStack>
    )
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Welcome!"
      primaryAction={open === 'welcome' ? {
        content: 'Got it!',
        onAction: onClose
      } : {
        content: 'Get Credits',
        onAction: () => navigate('/plan')
      }}
      secondaryActions={open === 'welcome' ? null : [
        {
          content: 'Close',
          onAction: onClose
        }
      ]}
    >
      <Modal.Section>
        {content}
      </Modal.Section>
    </Modal>
  )
}
